import _classCallCheck from "/home/maxime/github/droneWorld/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/maxime/github/droneWorld/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { KeyCombo } from './key-combo';
export var Locale = /*#__PURE__*/function () {
  function Locale(name) {
    _classCallCheck(this, Locale);

    this.localeName = name;
    this.activeTargetKeys = [];
    this.pressedKeys = [];
    this._appliedMacros = [];
    this._keyMap = {};
    this._killKeyCodes = [];
    this._macros = [];
  }

  _createClass(Locale, [{
    key: "bindKeyCode",
    value: function bindKeyCode(keyCode, keyNames) {
      if (typeof keyNames === 'string') {
        keyNames = [keyNames];
      }

      this._keyMap[keyCode] = keyNames;
    }
  }, {
    key: "bindMacro",
    value: function bindMacro(keyComboStr, keyNames) {
      if (typeof keyNames === 'string') {
        keyNames = [keyNames];
      }

      var handler = null;

      if (typeof keyNames === 'function') {
        handler = keyNames;
        keyNames = null;
      }

      var macro = {
        keyCombo: new KeyCombo(keyComboStr),
        keyNames: keyNames,
        handler: handler
      };

      this._macros.push(macro);
    }
  }, {
    key: "getKeyCodes",
    value: function getKeyCodes(keyName) {
      var keyCodes = [];

      for (var keyCode in this._keyMap) {
        var index = this._keyMap[keyCode].indexOf(keyName);

        if (index > -1) {
          keyCodes.push(keyCode | 0);
        }
      }

      return keyCodes;
    }
  }, {
    key: "getKeyNames",
    value: function getKeyNames(keyCode) {
      return this._keyMap[keyCode] || [];
    }
  }, {
    key: "setKillKey",
    value: function setKillKey(keyCode) {
      if (typeof keyCode === 'string') {
        var keyCodes = this.getKeyCodes(keyCode);

        for (var i = 0; i < keyCodes.length; i += 1) {
          this.setKillKey(keyCodes[i]);
        }

        return;
      }

      this._killKeyCodes.push(keyCode);
    }
  }, {
    key: "pressKey",
    value: function pressKey(keyCode) {
      if (typeof keyCode === 'string') {
        var keyCodes = this.getKeyCodes(keyCode);

        for (var i = 0; i < keyCodes.length; i += 1) {
          this.pressKey(keyCodes[i]);
        }

        return;
      }

      this.activeTargetKeys.length = 0;
      var keyNames = this.getKeyNames(keyCode);

      for (var _i = 0; _i < keyNames.length; _i += 1) {
        this.activeTargetKeys.push(keyNames[_i]);

        if (this.pressedKeys.indexOf(keyNames[_i]) === -1) {
          this.pressedKeys.push(keyNames[_i]);
        }
      }

      this._applyMacros();
    }
  }, {
    key: "releaseKey",
    value: function releaseKey(keyCode) {
      if (typeof keyCode === 'string') {
        var keyCodes = this.getKeyCodes(keyCode);

        for (var i = 0; i < keyCodes.length; i += 1) {
          this.releaseKey(keyCodes[i]);
        }
      } else {
        var keyNames = this.getKeyNames(keyCode);

        var killKeyCodeIndex = this._killKeyCodes.indexOf(keyCode);

        if (killKeyCodeIndex !== -1) {
          this.pressedKeys.length = 0;
        } else {
          for (var _i2 = 0; _i2 < keyNames.length; _i2 += 1) {
            var index = this.pressedKeys.indexOf(keyNames[_i2]);

            if (index > -1) {
              this.pressedKeys.splice(index, 1);
            }
          }
        }

        this.activeTargetKeys.length = 0;

        this._clearMacros();
      }
    }
  }, {
    key: "_applyMacros",
    value: function _applyMacros() {
      var macros = this._macros.slice(0);

      for (var i = 0; i < macros.length; i += 1) {
        var macro = macros[i];

        if (macro.keyCombo.check(this.pressedKeys)) {
          if (macro.handler) {
            macro.keyNames = macro.handler(this.pressedKeys);
          }

          for (var j = 0; j < macro.keyNames.length; j += 1) {
            if (this.pressedKeys.indexOf(macro.keyNames[j]) === -1) {
              this.pressedKeys.push(macro.keyNames[j]);
            }
          }

          this._appliedMacros.push(macro);
        }
      }
    }
  }, {
    key: "_clearMacros",
    value: function _clearMacros() {
      for (var i = 0; i < this._appliedMacros.length; i += 1) {
        var macro = this._appliedMacros[i];

        if (!macro.keyCombo.check(this.pressedKeys)) {
          for (var j = 0; j < macro.keyNames.length; j += 1) {
            var index = this.pressedKeys.indexOf(macro.keyNames[j]);

            if (index > -1) {
              this.pressedKeys.splice(index, 1);
            }
          }

          if (macro.handler) {
            macro.keyNames = null;
          }

          this._appliedMacros.splice(i, 1);

          i -= 1;
        }
      }
    }
  }]);

  return Locale;
}();